import type { IncidentEntry } from "../lib/types";

type Severity = NonNullable<IncidentEntry["severity"]>;

export function SeverityIcon({
  severity,
  className = "w-3 h-3",
}: {
  severity: Severity;
  className?: string;
}) {
  if (severity === "info") {
    // dot
    return (
      <svg
        viewBox="0 0 16 16"
        className={className}
        fill="currentColor"
        aria-hidden="true"
      >
        <circle cx="8" cy="8" r="3" />
      </svg>
    );
  }
  if (severity === "let-op") {
    // diamond / warn
    return (
      <svg
        viewBox="0 0 16 16"
        className={className}
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 1 L15 8 L8 15 L1 8 Z" />
      </svg>
    );
  }
  if (severity === "actie") {
    // upward triangle / actie
    return (
      <svg
        viewBox="0 0 16 16"
        className={className}
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 2 L14 13 L2 13 Z" />
      </svg>
    );
  }
  // alarm — bolt
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M9 1 L3 9 L7 9 L6 15 L13 6 L9 6 Z" />
    </svg>
  );
}
